export const DEFAULT_WORKLIST_PAGE_TITLE = 'Worklist';
export const DEFAULT_ENABLE_SEARCH_BUTTON = true;
export const DEFAULT_ENABLE_FILTER_BUTTON = true;
export const DEFAULT_ENABLE_СHANGE_TAGS_OPTION = true;
export const DEFAULT_ENABLE_OUTSIDE_STUDIES_OPTION = true;
export const DEFAULT_SHOULD_SHOW_TAGS = true;
export const DEFAULT_IS_MY_PATIENTS = false;
export const DEFAULT_RETURN_URL = '/root/worklist';
export const MY_PATIENTS_RETURN_URL = '/root/worklist/mypatients';
export const STUDY_DETAILS_RETURN_URL = '/root/study/details';
export const MY_PATIENTS_BUTTOM_LABEL = 'Exam Detail';
export const DEFAULT_PERFORM_EXAM_BUTTON_LABEL = 'Perform Exam';
export const READY_FOR_THE_PATIENT_EXAM_BUTTON_LABEL = 'Ready For the Patient Exam';
export const WORKLIST_PAGE_URL = '/root/patient/';
export const CANNED_NOTES_FLAG_ID = -11;


// WEBPACK FOOTER //
// ./src/scripts/constants/worklist-constants.js